import { ActionHandlerParams } from "..";
import { getPageSetSurvey, saveSurveyAnswersInUserData } from "./util";
import { getCurrentSurveyAnswers } from "src/hooks/survey";

type Params = {
  completeDateField?: string;
};

/**
 * Used to minimially save answers to allow for rerolls,
 * without the entirety of survey finalization.
 */
export const saveAnswers = async ({
  params = {},
  store,
  pageSet,
  page,
}: {
  params?: Params;
} & ActionHandlerParams) => {
  const survey = getPageSetSurvey(pageSet, page);

  const { surveyNameSpace } = survey;
  const currentAnswers = getCurrentSurveyAnswers();

  await saveSurveyAnswersInUserData(
    store,
    surveyNameSpace,
    currentAnswers,
    params.completeDateField
  );
};
